module.exports = __webpack_public_path__ + "static/img/cbbj.a8a4105e.png";